import type { JSX } from "react";
import type { IconProps } from "@tamagui/helpers-icon";
export const ICON_STROKE_WIDTH = 2;

/** Type for any Tamagui/Lucide icon component */
export type IconComponent = (props: IconProps) => JSX.Element;
export type IconComponentProps = Omit<IconProps, "ref" | "size"> & {
  /** The icon component to render from @tamagui/lucide-icons */
  icon: IconComponent;
  size?: IconProps["size"];
  /** Accessible label for the icon. If omitted, icon is treated as decorative. */
  accessibilityLabel?: string;
};

/**
 * Wrapper component for Lucide icons that enforces consistent styling.
 */
export const Icon = ({
  icon: IconElement,
  strokeWidth = ICON_STROKE_WIDTH,
  size = "$iconMedium",
  accessibilityLabel,
  ...props
}: IconComponentProps) => {
  return <IconElement strokeWidth={strokeWidth} size={size} accessible={accessibilityLabel ? true : undefined} accessibilityLabel={accessibilityLabel} focusable={accessibilityLabel ? undefined : false} {...props} data-sentry-element="IconElement" data-sentry-component="Icon" data-sentry-source-file="Icon.tsx" />;
};